/**
 * Wrap any legacy form/detail page with Stitch ModulePage + form tokens.
 * Business logic stays in the child — no mock data.
 */
import React from "react";
import { ModulePage } from "./ModulePage";
import "./crane-tokens.css";
import "./stitch-forms.css";

export function StitchFormShell({
  crumbs = [],
  title,
  description = null,
  actions = null,
  children,
  print = false,
}) {
  return (
    <ModulePage crumbs={crumbs} title={title} description={description} actions={actions}>
      <div className={print ? "stitch-print-shell crane-card" : "stitch-form-shell crane-card"} style={{ padding: print ? 16 : 0, overflow: "visible" }}>
        {children}
      </div>
    </ModulePage>
  );
}

export default StitchFormShell;
